import { render } from "./SliderBlock.vue?vue&type=template&id=fad8c080"
import script from "./SliderBlock.vue?vue&type=script&lang=js"
export * from "./SliderBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__